//Collection of various utils
import * as THREE from "three";


export const getObject = function(objectName, scene) {
    let object = scene.getObjectByName(objectName);
    return object;
}

export const sleep = function(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const hexToRGB = function(h) {
    let rc = 0, gc = 0, bc = 0;

    if (h.length === 4) {
      rc = "0x" + h[1] + h[1];
      gc = "0x" + h[2] + h[2];
      bc = "0x" + h[3] + h[3];

    } else if (h.length === 7) {
      rc = "0x" + h[1] + h[2];
      gc = "0x" + h[3] + h[4];
      bc = "0x" + h[5] + h[6];
    }

    return {r: rc/255, g: gc/255, b: bc/255};
}

export const changeObjectOpacity = function(object, newOpacity) {
    getMeshes(object).forEach(m => {
        m.material.opacity = newOpacity;
    });
}

export const getMeshes = function(object) {
    let meshes = [];
    //console.log(object);
    object.traverse((o) => {
        if (o.isMesh) {
            meshes.push(o);
        }
    });
    return meshes;
}

export const addWireframe = function(object, linecolor) {
    let wireMaterial = new THREE.LineBasicMaterial({
        color: linecolor,
        linewidth: 1,
        transparent: true,
        opacity: 1,
        visible: true //Make them visible later on when needed, todo make this false
    });

    let meshes = getMeshes(object);
    meshes.forEach(o => {
        let geo = new THREE.EdgesGeometry(o.geometry);
        let wireframe = new THREE.LineSegments(geo, wireMaterial);
        o.add(wireframe);
    });
}

export const getRandomColor = function() {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export const getChildObject = function(parentName, childObjectName, scene) {
    //console.log("getChildObject fired, parentName: %s childObjectName: %s", parentName, childObjectName);
    let parentObj = getObject(parentName, scene);
    let childObjects = parentObj.children;
    let foundObj;
    childObjects.forEach(obj => {
        if(obj.name === childObjectName){
            foundObj = obj;
        }
    });
    return foundObj;
}

export const isParent = function(obj, givenParent) {
    //returns true or false if givenParent is a parent object of another object
    let currParent = obj.parent;
    let found = false;
    while(currParent.type !== "Scene"){ //Go through parents until we reach the scene object, rest before are Object3D's or groups
        if(currParent === givenParent){
            found = true;
            break;
        } else {
            currParent = currParent.parent;
        }
    }
    return found;
}

export const updateModelsOpacity = function(opacity, models) {
    //console.log("Changing opacity of models to: " + opacity);
    models.forEach(obj => {
        changeObjectOpacity(obj, opacity);
        if(opacity === 0){
            obj.visible = false;
        } else {
            obj.visible = true;
        }
    });
}

export const findSolarPanels = function(scene) {
    console.log("Finding solar panels.");
    let solarPanels = [];
    scene.traverse((o) => {
        if (o.name.startsWith("Solpanel_1053x1590_PA1")){
            solarPanels.push(o);
            o.visible = false;
        }
    });
    //this.currentVisiblePanels = 0;
    return solarPanels;
}